import { AProvider } from "src/framework/providers/AProvider";

class FinanciamentosPropostaProvider extends AProvider {
    constructor() {
        super("/pagamentos/financiamentos/proposta");
    }

}
export const financiamentosPropostaProvider = new FinanciamentosPropostaProvider()
export { FinanciamentosPropostaProvider }